import { FormattedMessage, useIntl } from 'react-intl';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { Table } from 'components/Table';
import Icon from 'components/commons/Icon';
import { MbChart } from 'components/MbChart';
import { SectionTitle } from 'components/SectionTitle';
import dayjs from 'utils/dayjs';
import { useParams } from 'react-router-dom';
import { DEFAULT_MOBILE_DATE_FORMAT, filterRatesByCurrency } from 'utils';
import { makeCurrenciesTypeRatesItems } from 'selectors';
import {
  Link,
  Wrapper,
  Info,
  Source,
  Header,
  StyledTableFooter,
} from './styles';
import Updated from '../commons/Updated';

const titles = ['сurrency', 'purchase', 'sale'];
const terms = [
  { type: 'sell', value: 'interbank' },
  { type: 'buy', value: 'interbank' },
];
const CurrencyTable = () => {
  const { currency } = useParams();
  const [isClosedMb, setIsClosedMb] = useState('undefined');

  const { formatMessage, locale } = useIntl();
  const { date = null } = useParams();

  const selectInterbankRates = useMemo(makeCurrenciesTypeRatesItems, []);

  const currenciesInterbankRatesItems = useSelector(state =>
    selectInterbankRates(state, {
      city: 'allCities',
      date: date || dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
      type: 'interbank',
    })
  );

  const getHref = currency => {
    return `/mb/${currency}/`;
  };

  useEffect(() => {
    const getHours = dayjs().format('HH');
    const getRange = 1 * getHours >= 10 && 1 * getHours <= 17;
    setIsClosedMb(getRange ? '0' : '1');
  }, [date]);

  const data = Object.fromEntries(
    Object.entries(currenciesInterbankRatesItems).filter(
      ([key]) => key === 'USD' || key === 'EUR'
    )
  );
  const rowData = filterRatesByCurrency(data, currency);

  return rowData.length > 0 ? (
    <Wrapper>
      <Header>
        <SectionTitle title="table.mb.mainTitle" />
        <Updated date={rowData[0]?.date} />
      </Header>

      {isClosedMb !== 'undefined' && (
        <Info closed={isClosedMb}>
          {isClosedMb === '1'
            ? formatMessage({ id: 'table.mb.info.closed' })
            : formatMessage({ id: 'table.mb.info.open' })}
        </Info>
      )}

      <Table type="mb" titles={titles} rows={rowData} getHref={getHref} />

      <StyledTableFooter>
        <Link href={`${locale === 'uk' ? '/ua' : ''}/currency/mb/`}>
          <FormattedMessage id="table.mb.link" />
          <Icon name="vectorStrokeMb" style={{ marginLeft: '10px' }} />
        </Link>

        <Source>
          <FormattedMessage id="table.source.mb.desc" />
        </Source>
      </StyledTableFooter>

      <MbChart
        terms={terms}
        chartTitle="dynamic.rates.chart.mb.title"
        type="interbank"
        isOpen={false}
      />
    </Wrapper>
  ) : null;
};

export default CurrencyTable;
